import { render, staticRenderFns } from "./BidForm.vue?vue&type=template&id=7973cec2&scoped=true"
import script from "./BidForm.vue?vue&type=script&lang=js"
export * from "./BidForm.vue?vue&type=script&lang=js"
import style0 from "./BidForm.vue?vue&type=style&index=0&id=7973cec2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7973cec2",
  null
  
)

export default component.exports